import "./InvestmentCriteria.css";
import ZoneHeading from "./ZoneHeading";

const InvestmentCriteria = () => {
  const Box = ({ header, text }) => {
    return (
      <div className="grid-item">
        <h3>{header}</h3>
        <p>{text}</p>
      </div>
    );
  };

  return (
    <div className="investment-zone">
      <div className="zone">
        <ZoneHeading id="investments">Investment Criteria</ZoneHeading>
        <div className="investments-grid-container">
          <Box header="Region" text="North America" />
          <Box header="EBITDA" text="$3 million - $30 million" />
          <Box header="Transaction size" text="$10 million - $200 million" />
          <Box header="Ownership" text="Family/founder-owned" />
          <Box
            header="Transaction type"
            text="Buyouts, buy-and-builds, corporate carve-outs, structured equity, recapitalizations"
          />
          <Box header="Investment type" text="Majority equity" />
        </div>
      </div>
    </div>
  );
};

export default InvestmentCriteria;
